module.exports = __webpack_public_path__ + "img/product_33.4861d85.svg";